import { createAction, props } from "@ngrx/store";

const prefix = "[Skill Types Page]";

export const loadPage = createAction(`${prefix} Load Page`);
export const requestAddSkillType = createAction(
  `${prefix} Request Add Skill Type`,
  props<{ name: string }>(),
);
export const editSkillTypeDialogClosed = createAction(
  `${prefix} Edit Skill Type Dialog Closed`,
);
export const deleteSkillTypeDialogClosed = createAction(
  `${prefix} Delete Skill Type Dialog Closed`,
);
